module.exports = __webpack_public_path__ + "static/media/file-upload.3d52fbf3.svg";